/// <reference path="appbase.ts" />

namespace TerminalApp {
    let appId = "app_production";

    class ProductionItem {
        container = document.createElement("div");
        errorTimeout: any = null;

        showError(message: string) {
            SP.Sounds.Error.play();
            var err = this.container.querySelector(".error") as HTMLElement;
            err.style.display = "block";
            err.innerHTML = message;

            clearTimeout(this.errorTimeout);
            this.errorTimeout = setTimeout(() => {
                err.style.display = "none";
            }, 3000);
        }

        constructor(pi: SP.ProductionInfo) {

            var assemblyValue = Math.min(pi.missingAssembly, pi.item.assemblableQuantity);
            var disassemblyValue = Math.min(pi.missingDisassembly, pi.item.disassemblableQuantity);

            this.container.innerHTML = `
            <div class="item_box1 noselect">
                <div class="inner">
                    <img class="image" src="${pi.item.imageUrl}">
                    <div class="text">
                        <span class="sku">${pi.item.sku}</span>
                        <span class="description">${pi.item.description}</span>
                        <span class="barcode">${pi.item.barcodes.join(", ")}</span>
                    </div>
                    <table>
                        <tr>
                            <td style='display:none' class='assemble_elm'>
                                <div class="pick_status_box noselect"><div class="button minus grad-gray"><i class="fas fa-minus"></i></div><div class="input_box" style="width: calc(100% - 210px);"><input  type="number" value="${assemblyValue}"> / <span class="max_qty">${pi.missingAssembly}</span> / <span class="max_qty">${pi.item.assemblableQuantity}</span></div><div class="button plus grad-gray"><i class="fas fa-plus"></i></div><div style="width:100%" class="button confirm-btn grad-green"><i style="font-size:25px; vertical-align: -4px; margin-right: 10px;" class="fa-solid fa-arrow-down-to-arc"></i> ${SP.Localize("word_assemble")}</div></div>
                            </td>
                            <td  style='display:none' class='disassemble_elm'>
                                <div class="pick_status_box noselect"><div class="button minus grad-gray"><i class="fas fa-minus"></i></div><div class="input_box" style="width: calc(100% - 210px);"><input type="number" value="${disassemblyValue}"> / <span class="max_qty">${pi.missingDisassembly}</span> / <span class="max_qty">${pi.item.disassemblableQuantity}</span></div><div class="button plus grad-gray"><i class="fas fa-plus"></i></div><div style="width:100%" class="button confirm-btn grad-red"><i style="font-size:25px; vertical-align: -4px; margin-right: 10px;" class="fa-solid fa-arrow-up-from-arc"></i> ${SP.Localize("word_disassemble")}</div></div>
                            </td>
                        </tr>
                    </table>
                    <div style="clear: both;"></div><div class="error"></div>
                </div>
            </div>
            `;

            if (pi.item.collectionAllowAssembly) {
                this.initSection(".assemble_elm", pi.item.assemblableQuantity, async (qty) => {
                    try {
                        StartLoading();
                        var result = await SP.get<any>(`/api/v1/item/collectionAssembly?itemId=${pi.item.id}&qty=${qty}&assemble=true`);
                        if (result.status != 200) this.showError(result.msg);
                        else {
                            SP.Sounds.Success.play();
                            App_Production.instance.open({ itemId: SP.getHash("itemId") }) //reload
                        }

                    } finally {
                        StopLoading();
                    }
                });
            }

            if (pi.item.collectionAllowDisassembly) {
                this.initSection(".disassemble_elm", pi.item.disassemblableQuantity, async (qty) => {
                    try {
                        StartLoading();
                        var result = await SP.get<any>(`/api/v1/item/collectionAssembly?itemId=${pi.item.id}&qty=${qty}&assemble=false`);
                        if (result.status != 200) this.showError(result.msg);
                        else {
                            SP.Sounds.Success.play();
                            App_Production.instance.open({ itemId: SP.getHash("itemId") }) //reload
                        }

                    } finally {
                        StopLoading();
                    }
                });
            }

        }

        initSection(query: string, max: number, callback: (qty: number) => void) {
            var section = this.container.querySelector(query) as HTMLElement;
            var plus = section.querySelector(".plus");
            var minus = section.querySelector(".minus");
            var input = section.querySelector("input") as HTMLInputElement;
            var btn = section.querySelector(".confirm-btn");

            section.style.display = "";

            plus.addEventListener("click", () => {
                var current = parseInt(input.value) ?? 0;
                if (current + 1 <= max) {
                    input.value = Math.max(0, Math.min(max, current + 1)).toString();
                    SP.Sounds.Click.play();
                }
                else {
                    SP.Sounds.Error.play();
                }

            });

            minus.addEventListener("click", () => {
                var current = parseInt(input.value) ?? 0;
                if (current - 1 >= 0) {
                    input.value = Math.max(0, Math.min(max, current - 1)).toString();
                    SP.Sounds.Click.play();
                }
                else {
                    SP.Sounds.Error.play();
                }
            });

            input.addEventListener("focus", () => {
                input.select();
            });

            input.addEventListener("input", () => {
                var current = parseInt(input.value) ?? 0;
                if (current < 0 || current > max)
                    input.value = Math.max(0, Math.min(max, current)).toString();
            });

            btn.addEventListener("click", () => {
                var current = parseInt(input.value) ?? 0;

                if (current > 0) {
                    callback(current);
                }
                else {
                    this.showError(SP.Localize("sentance_qty_must_be_greater_than_0"));
                }
            });
        }

    }


    export class App_Production extends AppBase {
        p_content = document.getElementById("p_content");
        p_search_item = document.getElementById("p_search_item");
        p_search_ean = document.getElementById("p_search_ean");
        p_quick_production = document.getElementById("p_quick_production");
        p_quick_count = document.getElementById("p_quick_count");
        static instance: App_Production;
        constructor() {
            super(appId);
            App_Production.instance = this;
            this.p_search_item.addEventListener("click", () => {
                itemSearchAssistant.open(null, null, false, (item) => {
                    this.addProductionItemFromId(item.id);
                }, [SP.ItemType.Collection]);
            });

            this.p_search_ean.addEventListener("click", () => {
                itemSearchAssistant.open(null, null, true, (item) => {
                    this.addProductionItemFromId(item.id);
                }, [SP.ItemType.Collection]);
            });

            this.p_quick_production.addEventListener("click", async () => {
                var count = prompt("Enter order Amount", "20");

                if (count !== undefined) {

                    //generate summary
                    var info = await SP.Data.QuickProduction.getInfo(parseInt(count), false);
                    var message = `
                            <h1>Start production of:</h1>
                            ${info.productionItems.map(i => `<b>${i.quantity} ${i.item.unitType} - </b> ${i.item.description}`).join('<br />')}
                            <h1>Orders:</h1>
                            <b>${info.orders.join(", ")}</b>
                    `;

                    //confirm production
                    if (await SP.confirmX(message)) {
                        StartLoading();
                        try {
                            var result = await SP.get<any>(`/api/v1/production/start?OrderQty=${count}`);
                            if (result.status != 200) alert(result.msg);
                            else {
                                SP.Sounds.Success.play();
                                App_Production.instance.open({ itemId: SP.getHash("itemId") }) //reload
                            }
                        }
                        finally {
                            StopLoading();
                        }
                    }
                }
            });

        }

        clear() {
            this.p_content.innerHTML = "";
        }

        async onOpen() {
            this.clear();

            var quickInfo = await SP.Data.QuickProduction.getInfo(1000000, true);
            this.p_quick_count.innerHTML = quickInfo.totalOrders.toString();
            console.log("quickInfo:", quickInfo);



            var itemId = SP.getHash("itemId");
            if (itemId) {
                this.addProductionItemFromId(itemId);
            }
            else {
                var data = await SP.Data.Item.getProductionInfos(20);
                console.log("data", data);
                data.forEach(d => { this.addProductionItem(d); });
            }
        }

        async onClose() {

        }



        async addProductionItemFromId(itemId: string) {
            this.clear();
            ignoreHashChange = true;
            SP.setHash("itemId", itemId);
            await SP.sleep(1);
            ignoreHashChange = false;

            let pi = await SP.Data.Item.getProductionInfo(itemId);
            this.addProductionItem(pi);
        }


        addProductionItem(pi: SP.ProductionInfo) {
            var itm = new ProductionItem(pi);
            this.p_content.appendChild(itm.container);
        }
    }



    RegisterApp(appId, App_Production);
}